import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useTranslation from '../../components/hooks/useTranslation';
import { announcementAcknowledged } from '../../store/actions/announcement/announcementAcknowledged';
import { announcementToShowSelector } from '../../store/selectors/announcementSelectors';

function SnackbarContainer() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const announcements = useSelector(announcementToShowSelector);
  const dispatch = useDispatch();
  const translatedStrings = useTranslation();
  useEffect(() => {
    announcements.forEach((announcement) => {
      enqueueSnackbar(translatedStrings.announcements[announcement.announcementType], {
        key: announcement.uuid,
        autoHideDuration: 3000,
        variant: 'default',
        action: (key) => (
          <IconButton size="large" key="closeButton" color="inherit" aria-label="Close" onClick={() => closeSnackbar(key)}>
            <CloseIcon />
          </IconButton>
        ),
      });
      dispatch(announcementAcknowledged({ uuid: announcement.uuid }));
    });
  });

  return null;
}

export default SnackbarContainer;
